import React from 'react';
import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import EditManufacturersForm from '../../../component/manufacturerComps/EditManufacturersForm';

const EditManufacturers = () => {


  return (
    <div >
      <InformationHeader mainpage="Dashboard" prevpage="Manufacturer"  pagename="Edit Manufacturer" buttonText="Update category"/>
      <EditManufacturersForm />
    </div>
  );
};

export default EditManufacturers;
